import { Autocomplete, OutlinedInput } from "@mui/material";
import { slug } from "@resamare/functions";
import { useId, useState } from "react";
import { ChevronBottomIcon, CloseIcon } from "../../General";
import { Stack } from "../../Layout";
import { FormControl, FormHelperText, FormInputProps, FormLabel } from "../_partials";
import inputStyles from "../_partials/FormInput/FormInput.module.scss";
import styles from "./AutocompleteField.module.scss";

export type SelectOption = {
    label: string;
    value: string;
};

export interface AutocompleteFieldProps
    extends Pick<FormInputProps, "inputRef" | "name" | "placeholder"> {
    helperText?: string;
    isDisabled?: boolean;
    isError?: boolean;
    label: string;
    options: SelectOption[];
    onChange: (value: SelectOption | null) => void;
    value: SelectOption | null;
}

export function AutocompleteField({
    helperText = "",
    inputRef,
    isDisabled = false,
    isError = false,
    label,
    options,
    name,
    onChange,
    placeholder,
    value,
}: AutocompleteFieldProps) {
    const id = useId();

    const [inputValue, setInputValue] = useState("");

    return (
        <Stack gap={0.5}>
            <Autocomplete
                autoComplete={false}
                classes={{
                    popupIndicator: styles["indicator"],
                    clearIndicator: styles["indicator"],
                }}
                className={styles["autocomplete"]}
                clearIcon={<CloseIcon />}
                disabled={isDisabled}
                fullWidth
                id={id}
                inputValue={inputValue}
                noOptionsText="Aucun résultat"
                onChange={(_event, newValue) => {
                    onChange(newValue);
                }}
                onInputChange={(_event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                openOnFocus
                options={options}
                popupIcon={<ChevronBottomIcon />}
                ref={inputRef}
                renderInput={({ InputProps, inputProps }) => (
                    <FormControl isError={isError}>
                        <Stack gap={0.5}>
                            <FormLabel htmlFor={id}>{label}</FormLabel>
                            <OutlinedInput
                                {...InputProps}
                                classes={{ root: styles["input-root"] }}
                                className={`${inputStyles["fieldset"]} ${isDisabled ? inputStyles["fieldset--is-disabled"] : ""}`}
                                disabled={isDisabled}
                                inputProps={{
                                    ...inputProps,
                                    className: `${inputStyles["input"]}`,
                                }}
                                name={name}
                                placeholder={placeholder}
                            />
                        </Stack>
                    </FormControl>
                )}
                renderOption={(props, option) => (
                    <li {...props} key={slug(option.value)}>
                        {option.label}
                    </li>
                )}
                value={value}
            />
            {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
        </Stack>
    );
}
